module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"slogan":"Сервис видеособеседований с человеческим лицом"}}')
  delete Component.options._Ctor
}
